import {
  EDIT_SERVICE_TYPE,
  FETCH_SERVICE_TYPE,
  UPDATE_ACTIVE_TO_ORCAMENT_TYPE,
} from './ServiceTypeActions'

const INITIAL_STATE = {
  items: [],
  filters: {},
  meta: {},
  editingServiceType: null,
  measureType: [],
  attendanceType: [],
  serviceCategory: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SERVICE_TYPE.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        meta: action.payload.data.meta,
        measureType: action.payload.data.measureType,
        attendanceType: action.payload.data.attendanceType,
        serviceCategory: action.payload.data.serviceCategory,
        filters: action.payload.filters,
      }
    case EDIT_SERVICE_TYPE.SUCCESS:
      return {
        ...state,
        editingServiceType: action.payload,
      }
    case UPDATE_ACTIVE_TO_ORCAMENT_TYPE.SUCCESS:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.data.id
            ? { ...item, active_to_orcament: action.payload.data.active_to_orcament }
            : item
        ),
      }
    default:
      return state
  }
}

export const getServiceTypeListData = state => {
  return {
    items: state.serviceType.items,
  }
}
